export default __webpack_public_path__ + "static/eating-8fafead14c408747331252efa341d156.svg";